import {
  TRegisterPatientInfoParams,
  TPatientInfoResponse,
} from 'types/apis/patient';
import { TAgreeParticipationForm } from 'types/form/patient';

export const RegisterPatientDefaultValues: TRegisterPatientInfoParams = {
  name: '',
  phoneNum: '',
  birthDate: '',
  sex: '',
  relation: '',
  occupation: '',
  complaint: '',
};

export const PatientInfoDefaultValues: TPatientInfoResponse = {
  name: '',
  phoneNum: '',
  birthDate: '',
  sex: '',
  relation: '',
  occupation: '',
  agreeDate: '',
  complaint: '',
};

export const AgreeParticipationFormDefaultValues: TAgreeParticipationForm = {
  isAgree: 'agree',
};
